// CheckboxCell.tsx
import React from 'react';
import { Check } from 'lucide-react';

interface CheckboxCellProps {
  value: any;
  config?: any;
  onChange?: (value: string) => void;
  readOnly?: boolean;
}

export const CheckboxCell: React.FC<CheckboxCellProps> = ({ value, config, onChange, readOnly }) => {
  let isChecked = false;
  try {
    if (typeof value === 'string') {
      const parsed = JSON.parse(value);
      isChecked = parsed.checked || parsed === true || parsed === 'true';
    } else if (typeof value === 'boolean') {
      isChecked = value;
    } else if (value?.checked !== undefined) {
      isChecked = value.checked;
    }
  } catch (e) {
    isChecked = value === 'true' || value === true;
  }

  const handleToggle = () => {
    if (onChange && !readOnly) {
      onChange(JSON.stringify({ checked: !isChecked }));
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={readOnly}
      className={`w-8 h-8 rounded border-2 flex items-center justify-center transition-all disabled:cursor-not-allowed ${
        isChecked
          ? 'bg-green-500 border-green-500'
          : 'bg-white border-gray-300 hover:border-gray-400'
      }`}
    >
      {isChecked && <Check className="w-5 h-5 text-white" />}
    </button>
  );
};

